import { useState, useRef, useCallback } from "react";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Icon,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import AgGridTable from "../../utilities/AgGridTable";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";

export default function ProjectOverview(props) {
  const theme = useTheme();
  const { open, handleClose, handleBack, selectedRowData } = props;
  const gridRef = useRef();
  const navigate = useNavigate();
  const [columnDefs, setColumnDefs] = useState([
    { headerName: "Sno.", valueGetter: "node.rowIndex + 1", maxWidth: 70 },
    { field: "typeName", headerName: "TYPE Name" },
    { field: "uniqId", headerName: "Uniq ID" },
    { field: "commisionName", headerName: "Commission Name" },
    { field: "volume", headerName: "Volume" },
    { field: "WG1Price", headerName: "LPWG1" },
    { field: "WG2Price", headerName: "LPWG2" },
    { field: "totalWGPrice", headerName: "TOTAL LP" },
    { field: "range", headerName: "RANGE-1" },
    { field: "color", headerName: "FRONT" },
    { field: "carcass", headerName: "CARCASS" },
    { field: "handle", headerName: "HANDLE" },
  ]);
  const onGridReady = useCallback((params) => {
    //loadRates();
  }, []);

  const handlePlaceOrder = () => {
    navigate("/order/new-order-list");
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
      <AppBar position="static">
        <Toolbar className="flex w-full justify-between">
          <Typography variant="subtitle1" color="inherit">
            Project Overview
          </Typography>
          <IconButton onClick={handleClose} color="inherit">
            <Icon>close</Icon>
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent sx={{ height: 500 }}>
        <div
          className={`h-full ${theme.palette.mode === "dark"
            ? "ag-theme-alpine-dark"
            : "ag-theme-alpine"
            }`}
        >
          <AgGridTable
            rowData={selectedRowData}
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            gridRef={gridRef}
            hideCheckbox={true}
            editable={false}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={handleBack}>Back</Button>
        <Button variant="contained" color="primary" onClick={handlePlaceOrder}>Place Order</Button>
      </DialogActions>
    </Dialog>
  );
}
